class ConsoleLogger {
  constructor(game, scene, config, id) {
    this.id = id;
  }

  log(...args) {
    if (JW_DEBUG) {
      console.log(...args);
    }
  }

  getLoggerVisibility() {}

  setLoggerVisibility(value) {}

  updatePosition() {}

  destroy() {}
}

export { ConsoleLogger };
